import styled from '@emotion/styled';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const containerPaddingCss = {
  padding: '64px 0',
  [MediaQueries.md]: {
    padding: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    padding: '160px 0',
  },
};

export const containerMarginCss = {
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
};

export const TitleText = styled.h2({
  ...typography.effra40,
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  marginBottom: 20,
  [MediaQueries.mdAndUp]: {
    marginBottom: 11,
  },
});

export const SubtitleText = styled.div({
  ...typography.effra16,
  color: colorsPalette.grey,
  fontWeight: fontWeights.regular,
  marginBottom: 35,
  [MediaQueries.mdAndUp]: {
    marginBottom: 26,
  },
});

export const columnStyles = {
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    alignItems: 'center',
  },
};

export const Line = styled.div({
  width: '100%',
  height: 1,
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  [MediaQueries.sm]: {
    display: 'none',
  },
});
